import { APayoutAWalletCanRequest } from '../../domains/the-payout-a-wallet-can-request';
import {
  CreatePayoutRequestResponse,
  GetPayoutDetailsRequestParams,
  GetPayoutDetailsResponse,
  GetPayoutHistoryResponse,
  PayoutRequestDto,
} from '@smatchy/sdk';
enum PayoutStatus {
  Pending = 'pending',
  Approved = 'approved',
  InTransit = 'in_transit',
  Paid = 'paid',
  Declined = 'declined',
  Failed = 'failed',
  Canceled = 'canceled',
}
export interface GetPayoutHistoryDto {
  page?: number;
  limit?: number;
  status?: PayoutStatus;
  startDate?: string;
  endDate?: string;
}
export class GetPayouts {
  static readonly type = '[Organizer] Get Payouts';
  constructor(public payload: GetPayoutHistoryDto) {}
}
export class GetPayoutsSuccess {
  static readonly type = '[Organizer] Get Payouts Success';
  constructor(public payload: GetPayoutHistoryResponse) {}
}
export class GetPayoutDetails {
  static readonly type = '[Organizer] Get Payout Details';
  constructor(public query: GetPayoutDetailsRequestParams) {}
}
export class GetPayoutDetailsSuccess {
  static readonly type = '[Organizer] Get Payout Details Success';
  constructor(public payload: GetPayoutDetailsResponse) {}
}
export class CreatePayout {
  static readonly type = '[Organizer] Create Payout';
  constructor() {}
}
export class CreatePayoutSuccess {
  static readonly type = '[Organizer] Create Payout Success';
  constructor(public payload: CreatePayoutRequestResponse) {}
}
export class FailAction {
  static readonly type = '[Organizer] Action fail';
  constructor(public error: unknown) {}
}
export class GetPayoutAvailable {
  static readonly type = '[Organizer] Get Payout Available';
  constructor() {}
}
export class GetPayoutAvailableSuccess {
  static readonly type = '[Organizer] Get Payout Available Success';
  constructor(public payload: APayoutAWalletCanRequest[]) {}
}
